<script lang="ts">
  import { derived } from 'svelte/store';
  import AtAGlance from './AtAGlance.svelte';

  // types
  import type { Readable } from 'svelte/store';
  import type { Race, CrosswalkImage } from '../types';

  interface AtAGlanceRace {
    id: string;
    label: string;
    hyperlink?: string;
    store: Readable<Race | undefined>;
  }

  export let feed: AtAGlanceRace[];
  export let crosswalk: Record<string, CrosswalkImage>;
  export let maxCandidates = 2;
  export let hyperlinkInTitle = false;
  export let linkToLandingPage = false;
  /**
   * 'primary' shows the primary-only lines: "Top two advance to November
   * election" under the title and "Leading candidates" above each race.
   * Anything else ('general') hides them. This is b/c generally during the general
   * there are only 2 candidates. HOWEVER, for certain races there can be more than 2 candidates.
   * IF we use one of those races, we'll just have to adjust this
   */
  export let cycle = '';
  /** Show * next to incumbents and "* Incumbent" in the key */
  export let showIncumbents = false;

  $: races = feed;

  // this section makes it only appear when all races in the aag
  // component have results
  // $: allHaveVotes = derived(
  //   races.map(r => r.store),
  //   (values) => values.every(v => (v?.attributes.totalVotes ?? 0) > 0)
  // );

  $: has_incumbent = derived(
    races.map(r => r.store),
     (values) => values.some(v => v?.attributes.choices.some((c) => c.isIncumbent))
  );


  // Dereference all race stores into plain data so AtAGlance is presentational.
  $: raceDataStore = derived(
    races.map(r => r.store),
    (values) => races.map((r, i) => ({ ...r, data: values[i] }))
  );

</script>


<!-- {#if $allHaveVotes} -->
  <p class="aag-title">Key races at a glance</p>
  {#if cycle == 'primary'}
    <p class="section-deck">Top two advance to November election</p>
  {/if}
    <p class="aag-description text-sans-serif">
      <span><span class="check">✓</span> Winner</span>
      {#if $has_incumbent && showIncumbents}
        <span>* Incumbent</span>
      {/if}
    </p>
  <div class="aag-container">
    <div class="aag-races-container display-grid grid-cols-2 grid-gap-3 mb-3 mt-1">
      {#each $raceDataStore as race}
        <!-- race.data is undefined if the race ID isn't in its feed -->
        {#if race.data}
          <div class="race-container" id="aag-{race.id}">
            <AtAGlance
            race={race.data}
            label={race.label}
            hyperlink={race.hyperlink}
            {crosswalk}
            {maxCandidates}
            {hyperlinkInTitle}
            {cycle}
            {showIncumbents}
            />
          </div>
        {/if}
      {/each}
    </div>
    {#if linkToLandingPage}
      <a class="link-to-landing text-sans-serif" href="https://www.latimes.com/politics/story/2026-11-03/2026-midterm-election-live-results-california" target="_blank">See all results &raquo;</a>
    {/if}
  </div>
<!-- {/if} -->